export default "__VITE_ASSET__2073702c__"